// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vHQS","colMin":"styles_colMin__2mMxU"};